export const UNKNOWN_PIECE_ID = 0;

export const PIECE_TYPE_IDS = {
  "AlchemyBox_0": 261,
  "AlchemyBox_1": 262,
  "AlchemyBox_2": 263,
  "AlchemyBox_3": 264,
  "Blob_0": 521,
  "BloodBag_0": 121,
  "Bomb": 33,
  "Bookcase": 150,
  "Bookcase_0": 151,
  "Bookcase_1": 152,
  "Bookcase_2": 153,
  "Bookcase_3": 154,
  "Bookcase_4": 155,
  "Bookcase_5": 156,
  "Bookcase_6": 157,
  "Bookcase_7": 158,
  "BottomBoomerang": 67,
  "BottomLeftBoomerang": 73,
  "BottomRightBoomerang": 72,
  "Chains_0": 311,
  "Chains_1": 312,
  "Chains_2": 313,
  "ChargeBattery": 380,
  "ChargeBattery_0": 381,
  "ChargeBattery_1": 382,
  "ChargeBattery_2": 383,
  "ChargeBattery_3": 384,
  "ChargeBattery_4": 385,
  "Cinders": 74,
  "CloverGarden": 220,
  "CloverGarden_0": 221,
  "CloverGarden_1": 222,
  "CloverGarden_2": 223,
  "CloverGarden_3": 224,
  "CursedBookFive": 470,
  "CursedBookFive_0": 471,
  "CursedBookFive_1": 472,
  "CursedBookFive_2": 473,
  "CursedBookFive_3": 474,
  "CursedBookFive_4": 475,
  "CursedBookFour": 460,
  "CursedBookFour_0": 461,
  "CursedBookFour_1": 462,
  "CursedBookFour_2": 463,
  "CursedBookFour_3": 464,
  "CursedBookFour_4": 465,
  "CursedBookLT": 450,
  "CursedBookLT_0": 451,
  "CursedBookLT_1": 452,
  "CursedBookLT_2": 453,
  "CursedBookLT_3": 454,
  "CursedBookLT_4": 455,
  "CursedBookSquare": 270,
  "CursedBookSquare_0": 271,
  "CursedBookSquare_1": 272,
  "CursedBookSquare_2": 273,
  "CursedBookSquare_3": 274,
  "CursedBookSquare_4": 275,
  "DarkClouds_2": 363,
  "Dolphin_0": 301,
  "DragonBreathDown": 38,
  "DragonBreathLeft": 41,
  "DragonBreathRight": 77,
  "DragonBreathUp": 35,
  "ElectricTower": 370,
  "ElectricTower_0": 371,
  "Empty": 0,
  "EmptyFall": 3,
  "FireTile_0": 231,
  "FireTile_1": 232,
  "FireTile_2": 233,
  "FireWish": 75,
  "FishNet": 280,
  "FishNet_0": 281,
  "FishNet_1": 282,
  "FishNet_2": 283,
  "FishNet_3": 284,
  "Flare": 76,
  "Flower_1": 552,
  "GoldBag_4": 145,
  "Grass_0": 111,
  "Grass_1": 112,
  "HauntedTile_0": 241,
  "Honey_0": 161,
  "Honey_1": 162,
  "HorizontalRune": 31,
  "Horse_0": 191,
  "Ice_0": 531,
  "IceMetal_0": 541,
  "LavaBall_0": 331,
  "LavaBall_1": 332,
  "LavaBoulder": 320,
  "LavaBoulder_0": 321,
  "LavaBoulder_1": 322,
  "LeftBoomerang": 68,
  "LeftDiagonalRune": 51,
  "LightningStorm": 65,
  "LightningStrike": 64,
  "LightningWish": 63,
  "LightSpark": 60,
  "MagicalFruit_1": 412,
  "MagicGemCore_4": 355,
  "Malik_Bone_Golem": 1003,
  "Malik_Bone_Naga": 1007,
  "Malik_Ghost": 1002,
  "Malik_Necrotic_Egg": 1010,
  "Malik_Skeleton": 1004,
  "Malik_Skull_Big_Slime": 1006,
  "Malik_Skull_Big_Slime_Weak": 1016,
  "Malik_Skull_Slime": 1005,
  "Malik_Skull_Slime_Weak": 1015,
  "Malik_Snake": 1009,
  "Malik_Wall_Four": 1012,
  "Malik_Wall_Nine": 1013,
  "Malik_Wall_One": 1011,
  "Malik_Wall_One_Silver": 1014,
  "Malik_Zombie": 1008,
  "MegaDragonBreathDown": 79,
  "MegaDragonBreathLeft": 80,
  "MegaDragonBreathRight": 81,
  "MegaDragonBreathUp": 78,
  "MegaSpark": 62,
  "Mine": 53,
  "Multicolor": 34,
  "MulticolorBlue": 55,
  "MulticolorGreen": 54,
  "MulticolorRed": 57,
  "MulticolorYellow": 56,
  "NoElement": 2,
  "PartOf": 5,
  "Piece_Blue": 23,
  "Piece_Green": 21,
  "Piece_Red": 22,
  "Piece_Yellow": 24,
  "RandomElement": 20,
  "RightBoomerang": 69,
  "RightDiagonalRune": 52,
  "SarcophagusFive": 510,
  "SarcophagusFive_0": 511,
  "SarcophagusFive_1": 512,
  "SarcophagusFive_2": 513,
  "SarcophagusFive_3": 514,
  "SarcophagusFive_4": 515,
  "SarcophagusFour": 500,
  "SarcophagusFour_0": 501,
  "SarcophagusFour_1": 502,
  "SarcophagusFour_2": 503,
  "SarcophagusFour_3": 504,
  "SarcophagusFour_4": 505,
  "SarcophagusLT": 490,
  "SarcophagusLT_0": 491,
  "SarcophagusLT_1": 492,
  "SarcophagusLT_2": 493,
  "SarcophagusLT_3": 494,
  "SarcophagusLT_4": 495,
  "SarcophagusSquare": 440,
  "SarcophagusSquare_0": 441,
  "SarcophagusSquare_1": 442,
  "SarcophagusSquare_2": 443,
  "SarcophagusSquare_3": 444,
  "SarcophagusSquare_4": 445,
  "Shelf_0": 561,
  "ShipAnchor_0": 251,
  "SmartCannon": 36,
  "Spark": 61,
  "Spawner": 1,
  "Sphynx": 430,
  "Sphynx_0": 431,
  "Sphynx_1": 432,
  "Sphynx_2": 433,
  "Sphynx_3": 434,
  "Sphynx_4": 435,
  "Sphynx_5": 436,
  "Spider_0": 401,
  "SpiderWeb_0": 181,
  "StartRandomElement": 6,
  "StaticField_1": 392,
  "SteelBox_0": 131,
  "SteelBox_1": 132,
  "SteelBox_2": 133,
  "Teleporter": 4,
  "Tombstone_1": 482,
  "TopBoomerang": 66,
  "TopLeftBoomerang": 71,
  "TopRightBoomerang": 70,
  "TreasureMap_0": 171,
  "Turtle": 210,
  "Turtle_0": 211,
  "Turtle_1": 212,
  "VerticalRune": 30,
  "Volcano": 340,
  "Volcano_0": 341,
  "Volcano_1": 342,
  "Volcano_2": 343,
  "WateringCan_2": 203,
  "WoodenBox_0": 101,
  "WoodenBox_1": 102,
  "WoodenBox_2": 103,
  "WoodTotem": 420,
  "WoodTotem_0": 421,
  "WoodTotem_1": 422,
  "WoodTotem_2": 423,
  "WoodTotem_3": 424,
  "WoodTotem_4": 425,
  "WoodTotem_5": 426,
  "WoodTotem_6": 427,
  "WoodTotem_7": 428,
  "WoodTotem_8": 429,
  "Worm_1": 292
};

export function getPieceTypeId(type) {
  if (typeof type !== "string" || !type) return UNKNOWN_PIECE_ID;
  return PIECE_TYPE_IDS[type] ?? UNKNOWN_PIECE_ID;
}
